module.exports = __webpack_public_path__ + "img/dash-card-test.27edf6ce.svg";